import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'parent-contact',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './parent-contact.component.html',
  styleUrl: './parent-contact.component.css'
})

export class ParentContactComponent implements OnInit, OnChanges {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection8 = new EventEmitter<any>();

  yesNo = EYesNo;
  parentContactForm: FormGroup = new FormGroup([]);
  radioQuestions = [
    {
      id: 'student_parent_contact',
      questionText: "Have you had any contact with this student’s parents? *",
      formControlName: 'student_parent_contact',
      infoFormControlName: 'student_parent_contact_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teacherStaffInterviewData'] && this.teacherStaffInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.teacherStaffInterviewData && this.teacherStaffInterviewData[question.formControlName] !== undefined
                           ? this.teacherStaffInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.teacherStaffInterviewData?.[question.infoFormControlName] || '', disabled: this.teacherStaffInterviewData?.[question.infoFormControlName] ? false : true });
    });

    this.parentContactForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.parentContactForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.parentContactForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }  

  saveParentContact(): void {
    if (this.parentContactForm.valid) {
      this.onSaveSection8.emit(this.parentContactForm.value);
    }
  }

}
